import React from 'react';
import { Link } from 'react-router-dom';

export default function ContentSection({ 
    title, 
    highlightText, 
    description, 
    primaryButtonText, 
    primaryButtonLink, 
    secondaryButtonText, 
    secondaryButtonLink, 
    image,
    reverse = false,
    backgroundColor = 'offwhite' 
}) {
    const bgClass = backgroundColor === 'sage' ? 'bg-sage' : 'bg-offwhite';
    
    return (
        <section className={`${bgClass} border-b border-sage lg:h-[75vh] lg:flex lg:items-center`}>
            <div className={`${bgClass} mx-auto w-full max-w-screen-xl px-4 py-16 sm:px-6 sm:py-24 md:grid md:grid-cols-2 md:items-center md:gap-8 lg:px-8 ${reverse ? 'md:grid-flow-dense' : ''}`}>
                <div className={`max-w-prose text-left ${reverse ? 'md:col-start-2' : ''}`}>
                    <h1 className="font-heading text-3xl font-bold text-charcoal sm:text-4xl lg:text-5xl break-words">
                        {title}
                    </h1>
                    {highlightText && (
                        <h2 className="font-heading text-2xl font-bold text-forest sm:text-3xl lg:text-4xl mt-2 break-words">
                            {highlightText}
                        </h2>
                    )}

                    <p className="mt-4 text-base text-pretty text-charcoal sm:text-lg/relaxed lg:text-xl/relaxed">
                        {description}
                    </p>

                    <div className="mt-4 flex gap-4 sm:mt-6 lg:mt-8">
                        {primaryButtonText && primaryButtonLink && (
                            <Link
                                className="inline-block rounded border border-forest bg-forest px-5 py-3 font-medium text-white shadow-sm transition-colors hover:bg-leaf lg:px-6 lg:py-4"
                                to={primaryButtonLink}
                            >
                                {primaryButtonText}
                            </Link>
                        )}

                        {secondaryButtonText && secondaryButtonLink && (
                            <Link
                                className="inline-block rounded border bg-white px-5 py-3 font-medium text-charcoal shadow-sm transition-colors hover:bg-leaf hover:text-white lg:px-6 lg:py-4"
                                to={secondaryButtonLink}
                            >
                                {secondaryButtonText}
                            </Link>
                        )}
                    </div>
                </div>

                {image && (
                    <div className={`mx-auto mt-8 md:mt-0 ${reverse ? 'md:col-start-1 md:row-start-1' : ''}`}>
                        <img
                            src={image}
                            alt={title}
                            className="mx-auto max-w-md w-full h-auto rounded-lg shadow-lg lg:max-w-lg"
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
